/**
 * Endpoints of the inputer aggregator and merchant screens.
 *
 * Only the endpoints already migrated to the shared HTTP layer are listed here.
 * The remaining actions in the module still build their URL inline and will
 * move in a later sprint.
 *
 * @readonly
 * @enum {string}
 */
const api = {
  CREATE_AGGREGATOR: '/index.php?r=api/v1/client/inputer-aggregator/create',
  UPDATE_AGGREGATOR: '/index.php?r=api/v1/client/inputer-aggregator/update',
  UPDATE_MERCHANT: '/index.php?r=api/v1/merchant/inputer-merchant/update',
};

export default api;
